export const TAB_KEYS = {
  EMI: "emi",
  LOAN: "loan",
} as const;

export const TAB_LABELS = {
  [TAB_KEYS.EMI]: "EMI I can pay",
  [TAB_KEYS.LOAN]: "Loan amount I need",
};

export const TENURE_OPTIONS = [12, 24, 36, 48, 60, 84];

export const AVERAGE_TENURE = 48;
export const AVERAGE_PERCENTAGE = 11.6


// EMI
export const EMI_DEFAULT_VALUE = 15000; // or any sensible default
export const EMI_MIN = 5000;
export const EMI_MAX = 350000;
export const EMI_STEP = 100;

// Interest Rate
export const INTEREST_MIN = 6;
export const INTEREST_MAX = 18;
export const INTEREST_STEP = 0.1;
